module.exports = __webpack_public_path__ + "img/Connie Conner Rowe.3525916c.jpg";